import '../../App.scss'
import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import { withRouter } from "react-router-dom";
import Seo from '../seo/Seo';
import ArticlesList from './ArticlesList'
import ViewArticle from './ViewArticle';


class OurArticles extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {

        return (
            <div className="Museum">
                <Seo 
                title="Mystery Glyphs"
                image="https://1.bp.blogspot.com/-pBlgX3Qxfxc/YCxWzX2JuiI/AAAAAAAAnAw/1AxVaA_0dqUWsqry5XJoFX5v2nIsZ5kDgCLcBGAsYHQ/s1920/Mystery%2BGlyphs%2BCover.jpg"
                description="Across the Western United States a Mystery is Unfolding"

                />
                <Switch>
                    <Route exact path='/articles/' component={ArticlesList} />
                    <Route path='/articles/ahrf/:blogid/:postid/:title' component={ViewArticle} />
                </Switch>
                <div className="MuseumFooter">
                    <h1></h1>
                        <h2>Found something interesting? We want to hear from you!</h2>
                    <div id="widebutton"className="Register">
                        <p>Submit Exhibit for Display</p>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(OurArticles) 
